module.exports = __webpack_public_path__ + "b3e8452191df37c67197417e1cdd3b15.mp4";